export default __webpack_public_path__ + "static/media/triobanner.811fef31.png";